// @ts-nocheck
import React, { useState, useEffect } from 'react';
const _t = () => (window).__ENGPORTAL_THEME || null;
const _dark = { bg: "#0B1120", surface: "#111827", surfaceHover: "#1a2332", border: "#1E293B", borderLight: "#334155", text: "#E2E8F0", textMuted: "#94A3B8", textDim: "#64748B", accent: "#3B82F6", accentGlow: "rgba(59, 130, 246, 0.15)", green: "#10B981", yellow: "#F59E0B", red: "#EF4444", purple: "#8B5CF6", orange: "#F97316", cardShadow: "none", mode: "dark" };
const theme = new Proxy(_dark, { get: (fallback, prop) => { const t = _t(); return t ? t[prop] : fallback[prop]; }});
export default function MetricsPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const f = (url) => fetch(url, { credentials: 'same-origin' }).then(r => r.ok ? r.json() : null).catch(() => null);
    Promise.all([f('/api/workorders/'), f('/api/sprints/tasks/'), f('/api/equipment/'), f('/api/inventory/parts/'), f('/api/programs/programs/')])
      .then(([wo, tasks, eq, inv, pr]) => {
        setData({
          wos: Array.isArray(wo) ? wo : wo?.results || [],
          tks: Array.isArray(tasks) ? tasks : tasks?.results || [],
          eqs: Array.isArray(eq) ? eq : eq?.results || [],
          invs: Array.isArray(inv) ? inv : inv?.results || [],
          progs: pr?.all_programs || pr?.results || (Array.isArray(pr) ? pr : []),
        });
        setLoading(false);
      });
  }, []);
  if (loading || !data) return <div style={{ color: theme.textDim, padding: 40, textAlign: 'center' }}>Loading metrics...</div>;
  const { wos, tks, eqs, invs, progs } = data;
  const completedWOs = wos.filter(w => w.status === 'completed');
  const activeWOs = wos.filter(w => !['completed','cancelled','rejected'].includes(w.status));
  const doneTasks = tks.filter(t => t.status === 'done').length;
  // Avg turnaround
  let avgTurnaround = 0;
  const days = completedWOs.map(w => w.created_at && w.completed_at ? (new Date(w.completed_at) - new Date(w.created_at))/(1000*60*60*24) : null).filter(d => d !== null && d >= 0);
  if (days.length > 0) avgTurnaround = days.reduce((a,b)=>a+b,0)/days.length;
  // Program distribution
  const progMap = {};
  wos.forEach(w => {
    if (w.program) {
      let prog = progs.find(p => p.id === w.program);
      let root = prog;
      if (root) { while (root.parent) { const par = progs.find(p => p.id === root.parent); if (par) root = par; else break; } }
      const name = root ? (root.code || root.name) : 'Program #' + w.program;
      progMap[name] = (progMap[name]||0) + 1;
    }
  });
  const noProgCount = wos.length - wos.filter(w=>w.program).length;
  if (noProgCount > 0) progMap['No Program'] = noProgCount;
  const totalProg = Object.values(progMap).reduce((a,b)=>a+b,0);
  const woByType = {}; wos.forEach(w => { woByType[w.work_type] = (woByType[w.work_type]||0)+1; });
  const woByStatus = {}; wos.forEach(w => { woByStatus[w.status] = (woByStatus[w.status]||0)+1; });
  const taskByStatus = {}; tks.forEach(t => { taskByStatus[t.status] = (taskByStatus[t.status]||0)+1; });
  const Bar = ({ label, count, max, color, suffix }) => (
    <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:8 }}>
      <span style={{ color:theme.textMuted, fontSize:12, width:110, textTransform:'capitalize', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{label}</span>
      <div style={{ flex:1, background:theme.border, borderRadius:4, height:20, overflow:'hidden' }}>
        <div style={{ background:color, height:'100%', width:`${Math.max((count/Math.max(max,1))*100,5)}%`, borderRadius:4, display:'flex', alignItems:'center', paddingLeft:8, minWidth:24 }}>
          <span style={{ color:'#fff', fontSize:10, fontWeight:600 }}>{count}{suffix||''}</span>
        </div>
      </div>
    </div>
  );
  const kpis = [
    { label:'Total Work Orders', value:wos.length, color:theme.purple },
    { label:'Active WOs', value:activeWOs.length, color:theme.orange },
    { label:'Completed WOs', value:completedWOs.length, color:theme.green },
    { label:'Avg Turnaround', value:avgTurnaround>0?avgTurnaround.toFixed(1)+'d':'—', color:theme.accent },
    { label:'Tasks Done', value:`${doneTasks}/${tks.length}`, color:theme.yellow },
    { label:'Equipment', value:`${eqs.filter(e=>e.status==='available').length}/${eqs.length}`, color:theme.green },
  ];
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:20 }}>
      <h2 style={{ color:theme.text, fontSize:20, fontWeight:700, margin:0 }}>Metrics & Analytics</h2>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(6, 1fr)', gap:10 }}>
        {kpis.map(k => (
          <div key={k.label} style={{ background:theme.surface, border:`1px solid ${theme.border}`, borderRadius:10, padding:'14px 16px' }}>
            <div style={{ color:theme.textDim, fontSize:10, textTransform:'uppercase', marginBottom:6 }}>{k.label}</div>
            <div style={{ color:k.color, fontSize:28, fontWeight:700 }}>{k.value}</div>
          </div>
        ))}
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
        <div style={{ background:theme.surface, border:`1px solid ${theme.border}`, borderRadius:12, padding:20 }}>
          <div style={{ color:theme.text, fontSize:14, fontWeight:600, marginBottom:14 }}>Work Orders by Type</div>
          {Object.entries(woByType).sort((a,b)=>b[1]-a[1]).map(([t,c])=><Bar key={t} label={t.replace(/_/g,' ')} count={c} max={Math.max(...Object.values(woByType),1)} color={theme.purple}/>)}
        </div>
        <div style={{ background:theme.surface, border:`1px solid ${theme.border}`, borderRadius:12, padding:20 }}>
          <div style={{ color:theme.text, fontSize:14, fontWeight:600, marginBottom:14 }}>Tasks by Status</div>
          {Object.entries(taskByStatus).sort((a,b)=>b[1]-a[1]).map(([s,c])=>{
            const cl={todo:theme.textDim,in_progress:theme.accent,in_review:theme.yellow,blocked:theme.red,done:theme.green}[s]||theme.accent;
            return <Bar key={s} label={s.replace(/_/g,' ')} count={c} max={Math.max(...Object.values(taskByStatus),1)} color={cl}/>;
          })}
        </div>
        <div style={{ background:theme.surface, border:`1px solid ${theme.border}`, borderRadius:12, padding:20 }}>
          <div style={{ color:theme.text, fontSize:14, fontWeight:600, marginBottom:14 }}>Work Orders by Status</div>
          {Object.entries(woByStatus).sort((a,b)=>b[1]-a[1]).map(([s,c])=>{
            const cl={requested:theme.purple,approved:theme.accent,submitted:theme.yellow,in_progress:theme.orange,completed:theme.green,rejected:theme.red,cancelled:theme.textDim}[s]||theme.textDim;
            return <Bar key={s} label={s.replace(/_/g,' ')} count={c} max={Math.max(...Object.values(woByStatus),1)} color={cl}/>;
          })}
        </div>
        <div style={{ background:theme.surface, border:`1px solid ${theme.border}`, borderRadius:12, padding:20 }}>
          <div style={{ color:theme.text, fontSize:14, fontWeight:600, marginBottom:14 }}>Work Orders by Program</div>
          {Object.entries(progMap).sort((a,b)=>b[1]-a[1]).map(([n,c])=>{
            const pct = totalProg>0?((c/totalProg)*100).toFixed(1):'0';
            return <Bar key={n} label={n} count={c} max={Math.max(...Object.values(progMap),1)} color={theme.accent} suffix={` (${pct}%)`}/>;
          })}
          {Object.keys(progMap).length===0 && <div style={{color:theme.textDim,fontSize:12}}>No WOs with programs</div>}
        </div>
        <div style={{ background:theme.surface, border:`1px solid ${theme.border}`, borderRadius:12, padding:20 }}>
          <div style={{ color:theme.text, fontSize:14, fontWeight:600, marginBottom:14 }}>Equipment Status</div>
          {eqs.length>0?eqs.map(eq=>(
            <div key={eq.id} style={{display:'flex',justifyContent:'space-between',padding:'6px 0',borderBottom:`1px solid ${theme.border}08`}}>
              <span style={{color:theme.text,fontSize:12}}>{eq.name}</span>
              <span style={{background:(eq.status==='available'?theme.green:eq.status==='maintenance'?theme.yellow:theme.accent)+'22',color:eq.status==='available'?theme.green:eq.status==='maintenance'?theme.yellow:theme.accent,fontSize:10,padding:'2px 6px',borderRadius:4,fontWeight:600,textTransform:'capitalize'}}>{(eq.status||'').replace(/_/g,' ')}</span>
            </div>
          )):<div style={{color:theme.textDim,fontSize:12}}>No equipment added</div>}
        </div>
        <div style={{ background:theme.surface, border:`1px solid ${theme.border}`, borderRadius:12, padding:20 }}>
          <div style={{ color:theme.text, fontSize:14, fontWeight:600, marginBottom:14 }}>Inventory</div>
          <div style={{color:theme.accent,fontSize:36,fontWeight:700}}>{invs.length}</div>
          <div style={{color:theme.textDim,fontSize:12}}>Total parts tracked</div>
        </div>
      </div>
    </div>
  );
}
